type Props = {
  status: string
}

const SenderStatusCell = ({status}: Props) => {
  const statusText = status === '1' ? 'Active' : 'Inactive'

  return (
    <span className={`fs-7 badge ${status === '1' ? 'badge-light-success' : 'badge-light-danger'}`}>
      {statusText}
    </span>
  )
}

export default SenderStatusCell
